import Slider from './slider';

export default class MainSlider extends Slider {
    constructor(btns) {
        super(btns);
    }
    showSlides(n) {
        if (n > this.slides.length) {
            this.slideIndex = 1;
        }

        if (n < 1) {
            this.slideIndex = this.slides.length;
        }

        try {
            this.hanson.style.opacity = '0';

            if (n === 3) {
                this.hanson.classList.add('animated');
                setTimeout(() => {
                    this.hanson.style.opacity = '1';
                    this.hanson.classList.add('slideInUp');
                }, 3000);
            } else {
                this.hanson.classList.remove('slideInUp');
            }
        } catch (e) {}


        // Плавное исчезновение предыдущих слайдо
        this.slides.forEach(slide => {
            slide.style.opacity = '0';
            slide.style.display = 'none';
        });

        const currentSlide = this.slides[this.slideIndex - 1];
        currentSlide.style.display = 'block';

        // Плавное появление текущего слайда
        let opacity = 0;
        currentSlide.style.opacity = opacity;

        const fadeIn = setInterval(() => {
            if (opacity < 1) {
                opacity += 0.05;
                currentSlide.style.opacity = opacity;
            } else {
                clearInterval(fadeIn);
            }
        }, 50);
    }

    plusSlides(n) {
        this.showSlides(this.slideIndex += n);
    }

    render() {
        try {
            this.hanson = document.querySelector('.hanson');
        } catch (e) {}

        this.btns.forEach(item => {
            item.addEventListener('click', () => {
                this.plusSlides(1);
            });

            item.parentNode.previousElementSibling.addEventListener('click', (e) => {
                e.preventDefault();
                this.slideIndex = 1;
                this.showSlides(this.slideIndex);
            });
        });

        this.showSlides(this.slideIndex);
    }
}